import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

const icon1 = "https://winpeforum.com/assets/elements/Damodaran.png";
const icon2 = "https://winpeforum.com/assets/elements/Padmini.jpg";
 

let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.Speaker2 = [
     
  
  
        {
          imgUrl: icon1,
          desc: `<div>
M. Damodaran, IAS (Retd.), presently a governance consultant, advisor, mentor and coach, has worked
with the Union and the State governments in India, regulatory bodies, investment institutions, banks,
development financial institutions and with the private sector. He has headed the highly successful
restructuring efforts in Unit Trust of India (UTI) and Industrial Development Bank of India (IDBI). He has
been the Chairman of Securities and Exchange Board of India (SEBI). During his tenure at SEBI, he was
elected Chairman of the EMC of the International Organisation of Securities Commission (IOSCO).
He has chaired high powered committees of the Government of India, Reserve Bank of India (RBI) and
some chambers of commerce. He has won several awards, including some for governance, leadership
and transformation. He has been on the Boards of some of India’s biggest companies and on the Advisory Boards of some foreign entities and is the Founder Chairman of Indian Institute of Management
(IIM), Tiruchirappalli. He graduated with distinction in Economics and in Law from the Universities of
Madras and Delhi respectively. He is widely acknowledged as one of India’s foremost champions of
Corporate Governance and is passionate about improving Board performance.
 
          </div>`,
          name: "M. Damodaran",
          post: `<div>Founder & Chairperson<br/> Excellence Enablers

          </div>`,
        },
  ];
    this.Speaker1 = [
   
              {
          imgUrl: icon1,
          desc: `<div>
M. Damodaran, IAS (Retd.), presently a governance consultant, advisor, mentor and coach, has worked
with the Union and the State governments in India, regulatory bodies, investment institutions, banks,
development financial institutions and with the private sector. He has headed the highly successful
restructuring efforts in Unit Trust of India (UTI) and Industrial Development Bank of India (IDBI). He has
been the Chairman of Securities and Exchange Board of India (SEBI). During his tenure at SEBI, he was
elected Chairman of the EMC of the International Organisation of Securities Commission (IOSCO).
He has chaired high powered committees of the Government of India, Reserve Bank of India (RBI) and
some chambers of commerce. He has won several awards, including some for governance, leadership
and transformation. He has been on the Boards of some of India’s biggest companies and on the
 
Advisory Boards of some foreign entities and is the Founder Chairman of Indian Institute of Management
(IIM), Tiruchirappalli. He graduated with distinction in Economics and in Law from the Universities of
Madras and Delhi respectively. He is widely acknowledged as one of India’s foremost champions of
Corporate Governance and is passionate about improving Board performance.
 
          </div>`,
          name: "M. Damodaran",
          post: `<div>Founder & Chairperson<br/> Excellence Enablers

          </div>`,
        },
      
           
             {
          imgUrl: icon2,
          desc: `<div>
Padmini Khare Kaicker is the Managing Partner of B. K. Khare & Co., one of India’s most respected accounting firms with a six-decade legacy. Under her leadership, the firm has grown into a full-service practice with a strong national presence and a reputation for excellence, ethics, and innovation. A Chartered Accountant (ICAI) and CPA (USA), Padmini brings over 25 years of experience across sectors including Manufacturing, BFSI, Oil & Gas, IT, Hospitality, Real Estate, and Retail. She is widely recognised for her expertise as a Statutory Auditor, Strategic Advisor, and Independent Director.<Br/><Br/>
She currently serves on the boards of NPCI, Tata Chemicals (where she chairs the Audit Committee), Rallis India, Bosch Ltd., and Franklin Templeton Asset Management (IFSC). Her previous board roles include Kotak Mahindra Investments, J. B. Chemicals & Pharmaceuticals, IndusInd Bank, and Gabriel India.



 
          </div>`,
          name: "Ms Padmini Khare Kaicker",
          post: `<div>Directors on boards


          </div>`,
        },
    ];
 
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Women on Boards"
          image={"https://winpeforum.com/assets/wob/banner.jpg"}
          description="Winpe’s Women on Boards initiative partners with progressive companies to build stronger, more diverse boardrooms by increasing the representation of highly qualified, board-ready women leaders. The initiative provides access to a curated pool of exceptional candidates, board-readiness resources, and engagement models that align with companies’ governance goals and DEI commitments."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">
Module 2: Financial Oversight & Committee Excellence


              </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>Duration: 6 hours<br/>
When: 4th December 2025 at 10:00 am<br/>
Location: Taj Lands End, Mumbai</span>
                  
                </div>
              </div>
              <br/>
   
            <br/>  <div className="top_text" style={{textAlign: 'justify'}}> 
          


<h3><b>Key Areas of Coverage:</b></h3>
<ul><li> <h5><b>Financial Statements Analysis </b></h5></li>
<li> <h5><b>Audit Committees </b></h5></li>
<li> <h5><b>Nomination & Remuneration Committees </b></h5></li>
<li> <h5><b>Specialized Committee Structures </b></h5></li>
 
  </ul>

<br/>
 
<h3><b>Who Will It Benefit:</b></h3>
<p>Nominee Directors, Executive &amp; Non Executive Directors, Independent Directors, Aspiring
Directors</p>
              </div>
               
<div class="row">
  
<div class="col-md-12"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Faculty</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '70%' }}>
                          <div className="row">

{this.Speaker1.map((item, i) => {
 if(i<=2) 
 {
  return (
    <div
      className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-4 col-sm-12 col-lg-4"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div>

                        </center>
                      </div>
                 </div>   
                 
        
</div>

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/wob-training-module2/index.js